(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__ynEnquiryInit) {
      window.__ynEnquiryInit();
      return;
    }
    const positiveInteger = value => {
      if (!/^[1-9]\d*$/.test(String(value || ''))) return null;
      const number = Number(value);
      return Number.isSafeInteger(number) ? String(number) : null;
    };
    const bindEnquiry = section => {
      if (section.dataset.ynEnquiryBound) return;
      const form = section.querySelector('form');
      const panel = section.querySelector('details');
      const body = section.querySelector('textarea[name="contact[body]"]');
      const type = section.querySelector('select[name="contact[Enquiry type]"]');
      const studio = section.querySelector('select[name="contact[Preferred studio]"]');
      const language = section.querySelector('select[name="contact[Preferred language]"]');
      const product = section.querySelector('[data-enquiry-product]');
      const quantity = section.querySelector('[data-enquiry-quantity]');
      if (!form || !panel || !type || !studio || !product || !quantity) return;
      section.dataset.ynEnquiryBound = 'true';
      if (document.querySelector('[data-yn-enquiry]') !== section) {
        section.id = form.id + '-section';
        const alias = section.querySelector('.yn-enquiry-anchor');
        if (alias) alias.id = form.id + '-product';
      }
      const params = new URLSearchParams(window.location.search);
      const direct = params.get('enquiry') === 'product';
      const legacy = params.get('product_enquiry') === '1';
      const message = direct ? '' : params.get('enquiry');
      const storageKey = 'yn-product-enquiry:' + window.location.pathname + ':' + form.id;
      let restored = null;
      try {
        const saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
        if (panel.dataset.formState && saved && saved.productMode && Date.now() - saved.at < 1800000) restored = saved;
      } catch (_) {}
      const options = Array.from(product.options).filter(option => option.dataset.handle);
      if (!product.value) {
        const savedOption = restored && options.find(option => option.dataset.variant === restored.variant);
        const handle = params.get('product');
        const variant = params.get('variant');
        const matching = handle ? options.filter(option => option.dataset.handle === handle) : [];
        const requested = variant && /^\d+$/.test(variant) ? matching.find(option => option.dataset.variant === variant) : null;
        const selected = savedOption || (variant ? requested : matching[0]);
        if (selected) product.value = selected.value;
      }
      if (quantity.value === quantity.defaultValue) {
        quantity.value = positiveInteger(restored && restored.quantity) || positiveInteger(params.get('quantity')) || '1';
      }
      if (language) {
        const preferred = restored && restored.language;
        if (preferred && Array.from(language.options).some(option => option.value === preferred)) language.value = preferred;
        else if (!language.value) language.value = {en:'English',ko:'Korean',zh:'Chinese Simplified',ja:'Japanese'}[(section.dataset.locale || 'en').split('-')[0]] || 'English';
      }
      let productMode = false;
      const setMode = enabled => {
        productMode = enabled;
        section.dataset.productMode = String(enabled);
        section.querySelectorAll('[data-enquiry-mode]').forEach(node => {
          node.hidden = node.dataset.enquiryMode !== (enabled ? 'product' : 'general');
        });
        product.disabled = !enabled;
        quantity.disabled = !enabled;
        product.required = enabled;
        quantity.required = enabled;
        if (enabled) {
          type.value = 'Skincare product purchase';
          studio.value = 'Browns Bay - Monday Wednesday Friday Saturday';
          panel.open = true;
        }
      };
      setMode(direct || legacy || !!restored || window.location.hash === '#product-enquiry' || type.value === 'Skincare product purchase');
      if (message && body && !body.value.trim()) {
        body.value = message.slice(0, body.maxLength > 0 ? body.maxLength : 1000);
        panel.open = true;
      }
      const reveal = () => {
        if (window.location.hash === '#product-enquiry') setMode(true);
        if (window.location.hash === '#product-enquiry' || window.location.hash === '#treatment-enquiry') panel.open = true;
      };
      type.addEventListener('change', () => setMode(type.value === 'Skincare product purchase'));
      section.addEventListener('yn:enquiry-hash', reveal);
      form.addEventListener('submit', () => {
        try {
          if (productMode) {
            const selected = product.selectedOptions[0];
            window.sessionStorage.setItem(storageKey, JSON.stringify({productMode:true,variant:selected ? selected.dataset.variant : '',quantity:quantity.value,language:language ? language.value : '',at:Date.now()}));
          } else window.sessionStorage.removeItem(storageKey);
        } catch (_) {}
      });
      reveal();
    };
    window.__ynEnquiryInit = () => document.querySelectorAll('[data-yn-enquiry]').forEach(bindEnquiry);
    window.__ynEnquiryInit();
    document.addEventListener('shopify:section:load', window.__ynEnquiryInit);
    window.addEventListener('hashchange', () => {
      document.querySelectorAll('[data-yn-enquiry]').forEach(section => section.dispatchEvent(new Event('yn:enquiry-hash')));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yunara-massage-menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  const menus = () => document.querySelectorAll('.yn-massage-menu');
  const openMassageHash = (hash = window.location.hash) => {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    if (!id || id === 'massage-studios') {
      menus().forEach(menu => {
        const focusedInside = [...menu.querySelectorAll('.yn-massage-location')].some(studio => studio.contains(document.activeElement));
        menu.querySelectorAll('.yn-massage-location').forEach(studio => { studio.open = false; });
        if (focusedInside) menu.querySelector('.yn-massage-picker__link')?.focus({ preventScroll: true });
      });
      return;
    }
    const aliases = { 'browns-bay': 'browns-bay-body', glenfield: 'glenfield-body' };
    const target = document.getElementById(id) || document.getElementById(aliases[id] || '');
    const menu = target?.closest('.yn-massage-menu');
    if (!menu) return;
    const ancestors = [];
    for (let item = target; item && item !== menu; item = item.parentElement) {
      if (item.tagName === 'DETAILS') ancestors.push(item);
    }
    ancestors.reverse().forEach(item => { item.open = true; });
    requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'auto' }));
  };
  const initialize = () => {
    menus().forEach(menu => {
      const picker = menu.querySelector('.yn-massage-picker');
      if (!picker) return;
      picker.addEventListener('click', event => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href^="#"]');
        if (!link || !picker.contains(link)) return;
        openMassageHash(link.getAttribute('href'));
      });
      menu.querySelectorAll('.yn-massage-location').forEach(studio => {
        const summary = studio.querySelector(':scope > summary');
        summary?.addEventListener('click', () => {
          if (!studio.open || !studio.contains(document.activeElement)) return;
          requestAnimationFrame(() => {
            if (!studio.open) picker.querySelector('a[href="#' + studio.id + '"]')?.focus({ preventScroll: true });
          });
        });
      });
      menu.dataset.studioSelector = 'ready';
    });
    openMassageHash();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.addEventListener('hashchange', () => openMassageHash());
})();

  } catch(e) { console.error(e); }
})();
})();
